import configService from '../services/configService';
import storageService from '../services/storageService';

import createResource from './createResource';
import { Provider } from './types';

const providersResource = createResource<Provider>({
  key: 'providers',
  url: '/providers',
  // TODO: back-end > Support bulk for providers: `/providers/crudList?_id=:id1,:id2,:id2` is returning empty response
  hasFetchBulkSupport: false,
  processStrategy: (data) => ({
    ...data,
    // extended
    $srcAvatar: data.avatar
      ? `${configService.getApiBasePath()}/providers/${data.id}/avatar?token=${storageService.getToken()}`
      : '',
  }),
});

export default providersResource;
